import { SWRConfiguration } from 'swr';

import {
  Absence,
  GET_USER_ABSENCE_SWR_KEY,
  getUserAbsence,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
};

export const useGetEmployeeAbsenceData = (
  props: PropsType,
  swrConfig?: SWRConfiguration<Absence>,
): UseSWROutput<Absence> => {
  const { employeeId } = props;

  return useSWR(
    [GET_USER_ABSENCE_SWR_KEY, employeeId],
    ([_, employeeId]) => getUserAbsence(employeeId),
    swrConfig,
  );
};
